module.exports = __webpack_public_path__ + "media/images/icons/menu_timeline-caa876e3ea9bb90faaf8878956b5e436.svg";